import { Component, inject, Input, OnInit } from '@angular/core';
import { Compromiso } from 'src/app/shared/models/compromiso.model';
import { CompromisoService } from 'src/app/shared/services/compromiso.service';

@Component({
  selector: 'app-commitment-list',
  templateUrl: './commitment-list.component.html',
  styleUrls: ['./commitment-list.component.scss'],
})
export class CommitmentListComponent {
  @Input() compromisosList: Compromiso[] = [];
}
